import { z } from 'zod';

export const ThreadNewUrlParamsSchema = z.object({
    tool: z
        .string({
            description: 'The integration tool to add as context to the thread',
        })
        .nullable(),
    auto_submit: z
        .boolean({
            coerce: true,
            description:
                'Whether to automatically submit the thread when the user clicks the submit button',
        })
        .nullable(),
});
